export default "__VITE_ASSET__NG$IU6s3__"